var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGa4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "20px",
    height: "20px",
    viewBox: "0 0 48 48",
    id: "b",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m37.5,42.5h0c2.7614,0,5-2.2386,5-5V10.5c0-2.7614-2.2386-5-5-5h0c-2.7614,0-5,2.2386-5,5v27c0,2.7614,2.2386,5,5,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m24,42.5h0c2.7614,0,5-2.2386,5-5v-16c0-2.7614-2.2386-5-5-5h0c-2.7614,0-5,2.2386-5,5v16c0,2.7614,2.2386,5,5,5Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 10.5,
    cy: 37.5,
    r: 5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGa4);
export default __webpack_public_path__ + "static/media/ga4.42b45a3df7ab7b24f70a6c43bd24212d.svg";
export { ForwardRef as ReactComponent };